// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Container_wrap__rKwh7","fullSize":"Container_fullSize__pMapQ"};